import { useRef, useState } from 'react';
import './App.css';
import emailjs from '@emailjs/browser';

function App() {
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setSending(true);

    emailjs
      .sendForm(
        'service_77zvxqm',
        'template_6g5c47f',
        form.current,
        'kBj_mYkxC7Ypt6xRa'
      )
      .then(
        (result) => {
          console.log(result.text);
          setSuccess(true);
          setSending(false);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const formJsx = (
    <div>
      <form ref={form} className="form" onSubmit={sendEmail}>
        <input
          className="little-form__field"
          type="email"
          name="email"
          placeholder="Join our mailing list"
        />
        <button
          className={
            sending
              ? 'little-form__button little-form__button-disabled'
              : 'little-form__button'
          }
        >
          submit
        </button>
      </form>
    </div>
  );

  const messageSuccess = <div className="message">Success!</div>;

  return <div className="app">{success ? messageSuccess : formJsx}</div>;
}

export default App;
